import { Box, Text, useToast } from "@chakra-ui/react";


const handleToast = (toast: ReturnType<typeof useToast>, title: string) => {
    
    const isMobile = window.innerWidth < 600;
    const isTablet = window.innerWidth < 850;

    toast({
        render: () => {
            return <Box 
                bg='#F5F7F9'
                p={isMobile ? '15px' : '20px'} minH='60px'
                position='fixed' bottom='0' right='0'
                w={isMobile ? '100%' : isTablet ? 'calc(100vw - 200px)' : 'calc(100vw - 235px)'}
                h={isMobile ? '80px' : ''}
            >
                <Text 
                    variant='title' 
                    fontSize='md'                    
                >{title}</Text>
            </Box>
        }
    })
}

export default handleToast;